import { createContext } from 'react';

export const AuthContext = createContext({});

AuthContext.displayName = 'AuthContext';
